<template>
  <div class="reset-pass-container">
    <div class="container-child" v-if="token && userMail">
      <h2>איפוס סיסמה</h2>
      <p>*יש להזין סיסמה חדשה עם 8 תווים לפחות</p>
      <hr />
      <form>
        <label for="pass1">סיסמה חדשה</label>
        <input type="password" name="pass1" v-model="pass1" />
        <label for="pass2">אימות סיסמה</label>
        <input type="password" name="pass2" v-model="pass2" />
        <a
          @click="submitedData"
          class="waves-effect waves-light btn dolimo-style"
          @keyup.enter="submitedData"
          >שליחת סיסמה חדשה</a
        >
      </form>
    </div>
    <h1 v-else>אופס, כנראה שטעית בעמוד</h1>
  </div>
</template>
<script>
import AuthService from "@/services/AuthService";
export default {
  created() {
    if (this.$route.query.resetPassToken && this.$route.query.user) {
      this.token = this.$route.query.resetPassToken;
      this.userMail = this.$route.query.user;
    }
  },
  data() {
    return {
      pass1: "",
      pass2: "",
      token: "",
      userMail: "",
    };
  },
  methods: {
    async submitedData() {
      if (
        this.pass1.trim() !== this.pass2.trim() ||
        this.pass1 === "" ||
        this.pass2 === "" ||
        this.pass1.trim().length < 8
      ) {
        alert("י לשים לב שהוזנו סיסמאות זהות ואורך הסיסמה 8 תווים לפחות");
      } else {
        try {
          const response = await AuthService.createNewPassword(
            this.userMail,
            this.pass1,
            this.token
          );
          if (response.status == 200) {
            this.$router.push({ name: "loginPage" });
          } else {
            alert(`אירעה שגיאה באיפוס הסיסמה.
              מומלץ לחזור למסך הכניסה ולחזור על פעולת "איפוס הסיסמה".
              `);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 601px) {
  .container-child {
    width: unset !important;
    padding: 20px !important;
    border: unset !important;
  }
}
label {
  font-size: $extraSmallTextSize !important;
}
.btn {
  border-radius: unset;
}
hr {
  border: unset;
  border-top: solid 1px lightgrey;
  margin: 20px 0;
}

input {
  border: 1px #bbbbbb solid !important;
  margin: 10px 0 !important;
}
.reset-pass-container {
  display: flex;
  justify-content: center;
}
.container-child {
  width: 550px;
  padding: 40px;
  border: 1px solid lightgray;
  h2 {
    font-size: $largTextSize;
    margin: 0;
    margin-bottom: 10px;
  }
  p {
    margin: 0;
    color: rgb(146, 146, 146);
  }
}
</style>